<template>
    <div>
        <div class="page-header">
            <div class="pageTitle">
                <div class="pageName">{{ "Further Config for Line Profile  " + profileId }}</div>
            </div>
        </div>
        <div class="row">
            <div style="margin: 5px 15px 10px">
                <tabs v-model="defactiveIndex">
                    <pane label="Tcont Config">
                        <profileLineTcont :profileId="profileId" >
                        </profileLineTcont>
                    </pane>
                      <pane label="Gemport Config">
                        <profileLineGem :profileId="profileId" >
                        </profileLineGem>
                    </pane>
                    <pane label="Mapping Config">
                        <profileLineMap :profileId="profileId" :mapMode ="mapmode"  >
                        </profileLineMap>
                    </pane>
                    <pane label="Flow Config">
                        <profileLineFlow :profileId="profileId" >
                        </profileLineFlow>
                    </pane>
                      <pane label="Multicast Config">
                        <profileLineMcast :profileId="profileId" >
                        </profileLineMcast>
                    </pane>
                </tabs>
            </div>
        </div>
    </div>
</template>

<script>
import Pane from "./../components/Pane.vue"
import Tabs from "./../components/Tabs.vue"
import ProfileLineTcont from "./../views/ProfileLineTcont.vue"
import ProfileLineGem from "./../views/ProfileLineGem.vue"
import ProfileLineMap from "./../views/ProfileLineMap.vue"
import ProfileLineFlow from "./../views/ProfileLineFlow.vue"
import ProfileLineAlarm from "./../views/ProfileLineAlarm.vue"
import ProfileLineMcast from "./../views/ProfileLineMcast.vue"
import { get, post } from "@/utils/http.js"

export default {
    name: "profileLineStep",
    components: {
        Pane,
        Tabs,
        ProfileLineTcont,
        ProfileLineGem,
        ProfileLineMap,
        ProfileLineFlow,
        ProfileLineAlarm,
        ProfileLineMcast,
    },

    props:["profileId"],

    data() {
        return {
            defactiveIndex: 0,
            mapmode:  this.$route.query.mapmode,
        }
    }

}
</script>
